export const navLinkClass = (isActive: boolean): string =>
  isActive
    ? 'flex items-center gap-2 rounded-md p-2 text-sm font-semibold bg-accent-soft text-accent'
    : 'flex items-center gap-2 rounded-md p-2 text-sm font-medium text-muted hover:bg-surface-secondary hover:text-foreground';
